import React from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import { Skeleton } from '@mui/material';

import { useScreenSize } from '@context/screenSizeContext'

import "./carousel.css";

import { AssetUrl } from '@configuration/apiEndpoints';

const SLIDES_SKELETON = Array.from(Array(3).keys())

export default function Carousel({ data, loading = false, isError = false }) {
  const [emblaRef] = useEmblaCarousel({ loop: true }, [Autoplay()])
  const isSmallScreen = useScreenSize();

  const slides = [...data];
  while (slides.length < 3 && slides.length >= 1) {
    slides.push(...data.slice(0, 3 - slides.length));
  }

  return (
    <section className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {slides.map((data, index) => (
            <div className="embla__slide" key={index}>
              <img src={isSmallScreen ? `${AssetUrl}${data?.mobileImagePath}` : `${AssetUrl}${data?.desktopImagePath}`} width={'100%'} height={'100%'} alt={data?.bannerName}/>
            </div>
          ))}
          {( data.length === 0 ) &&
            SLIDES_SKELETON.map((index) => (
              <div className='embla__slide' key={index}>
                <Skeleton variant="rectangular" width={'100%'} height={'100%'} animation={!isError && 'pulse'}/>
              </div>
            ))
          }
        </div>
      </div>
    </section>
  )
}